<template>
  <v-dialog
    :value="show"
    fullscreen
    hide-overlay
    persistent
    class="toolbar"
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar>
        <v-toolbar-title>{{ $t('enums.env.choice') }}</v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-btn
            class="btn"
            icon
            @click="close"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <div class="pa-5">
        Plateforme: {{ `${device.platform} - ${device.version}` }}<br>
        Fabricant: {{ device.manufacturer }}<br>
        Modèle: {{ device.model }}<br>
        Num série: {{ device.serial }}
      </div>

      <v-divider />

      <v-radio-group
        v-model="environnement"
        class="pl-3"
      >
        <v-radio
          v-for="env in environnements"
          :key="env.value"
          :label="env.text"
          :value="env.value"
          class="pa-3"
        />
      </v-radio-group>

      <v-divider />

      <div class="pa-3">
        <v-btn
          x-large
          block
          @click="toSettings"
          v-text="$t('enums.env.settings')"
        />
        <v-btn
          v-if="IS_ANDROID"
          block
          class="mt-5"
          @click="exportDatabase"
          v-text="$t('enums.env.bdd')"
        />
        <v-btn
          v-if="IS_PAX"
          block
          class="mt-3"
          @click="exportPaxDatabase"
          v-text="$t('enums.env.pax_bdd')"
        />
      </div>

      <div
        class="pull-bottom bloc"
        style="margin-bottom: 80px"
      >
        <div
          v-if="IS_ANDROID"
          class="d-flex align-center px-5"
        >
          <v-switch
            v-model="useCcv"
            label="Utilisation Pinpad CCV"
            color="accent"
            @change="updateCcv"
          />
          <v-btn
            v-show="useCcv"
            class="ml-auto"
            @click="toCcvSettings"
          >
            Paramètres du Pinpad CCV
          </v-btn>
        </div>
      </div>

      <bottom-action
        name="env-dialog"
        btn-del
        @del="close"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import { MetierEnv } from 'modulewebservice'
import { $alert } from '@/modules/Utils'

export default {
  name: 'EnvDialog',

  model: {
    prop: 'show',
    event: 'change'
  },

  props: {
    show: { type: Boolean, default: false }
  },

  data () {
    return {
      IS_ANDROID,
      IS_PAX,
      envSelected: MetierEnv.getTypeEnv(),
      useCcv: localStorage.getItem('useCcv') === 'true',
      device: device
    }
  },

  computed: {
    environnement: {
      get () {
        return MetierEnv.getTypeEnv()
      },
      set (value) {
        this.envSelected = value
        this.$emit('change-env', value)
        MetierEnv.setTypeEnv(value)
      }
    },
    environnements () {
      return [
        { text: this.$i18n.t('enums.env.prod'), value: MetierEnv.typeEnvEnum.PROD },
        { text: this.$i18n.t('enums.env.int'), value: MetierEnv.typeEnvEnum.INT },
        { text: this.$i18n.t('enums.env.dev'), value: MetierEnv.typeEnvEnum.DEV }
      ]
    }
  },

  mounted () {
    setTimeout(() => {
      this.envSelected = MetierEnv.getTypeEnv()
      this.$emit('change-env', this.envSelected)
    }, 2500)
  },

  methods: {
    close () {
      this.$emit('change', false)
    },
    exportDatabase () {
      Cashless.exportDatabase(
        () => {
          $alert(this.$i18n.t('success.database_exported'), 'success')
        },
        (error) => {
          $alert(error)
        }
      )
    },
    exportPaxDatabase () {
      Pax.exportDatabase(
        () => {
          $alert(this.$i18n.t('success.database_exported'), 'success')
        },
        (error) => {
          $alert(error)
        }
      )
    },
    updateCcv (value) {
      localStorage.setItem('useCcv', value)
      CissAndroid.setUseCcv(value)
    },
    toCcvSettings () {
      CissAndroid.ccvSettings()
    },
    toSettings () {
      if (this.$route.name === 'index') {
        this.$router.replace({ name: 'settings', params: { checkConnected: false } })
      }
      this.close()
    }
  }
}
</script>
